import { ChangeEvent, ReactNode } from 'react';
import Input from '../../atoms/input';
import Page from '../../atoms/page';
import View from '../../atoms/view';

type SearchWidgetProps = {
  children?: ReactNode;
  extend?: object;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  title?: string;
  linkTitle?: string;
  onClickLink?: () => void;
  initialValue?: string;
};

const SearchWidget = ({
  children,
  extend,
  onChange,
  placeholder,
  title,
  linkTitle,
  onClickLink,
  initialValue,
}: SearchWidgetProps) => {
  return (
    <Page title={title} linkTitle={linkTitle} onClickLink={onClickLink}>
      <View extend={styles.row}>
        <Input
          extend={[extend && extend, styles.input]}
          type="text"
          placeholder={placeholder}
          defaultValue={initialValue}
          onChange={(event: ChangeEvent<HTMLInputElement>) => onChange?.(event)}
        />
        {children}
      </View>
    </Page>
  );
};

const styles = {
  input: {
    width: 250,
    marginTop: 30,
    marginBottom: 15,
    backgroundColor: 'white',
    marginLeft: 25,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignSelf: 'center',
  },
};

export default SearchWidget;
